module.exports = __webpack_public_path__ + "static/media/Latias_gaussian2.d7a209a7.png";